module.exports = __webpack_public_path__ + "static/media/img-tijuana.75a72299.jpg";